<template>
  <section >
    <h2 v-if="show_header" class="mb-1">Unterstützung</h2>
    <div v-if="text">
      {{text}}
      <div class="mt-1"><a class="no-deco" href="https://www.buymeacoffee.com/TobiasHubold" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/default-orange.png" alt="Buy Me A Coffee" style="height: 45px !important;width: 200px !important;" ></a></div>
    </div>
    <div v-else class="row">
      <!--
      <div class=" b-1 col-12">
        Du bist vom Round Table | Ladies Circle | Old Tablers | Tangent Club und möchtest in diese Übersicht mit aufgenommen werden, dann kannst du dich <router-link to="/eintragen" class="body-2 font-weight-bold primary-color">HIER</router-link> eintragen.
      </div>
      -->
      <div class="mt-1 pb-1 col-8 col-12-xsmall">
        Möchtest du darüber hinaus die Weiterentwicklung dieser Seite sichern, dann unterstütze den Betrieb durch einen Klick auf "Buy me a coffee". Jeglicher Überschuss kommt aktuell meinem Herzensprojekt <a class="primary-color" href="https://www.radzelten.de/" target="_blank"> "Music for Karakul"</a> zu Gute.
      </div>
      <div class="pt-05 mt-1 col-4 col-12-xsmall">
        <a class="no-deco" href="https://www.buymeacoffee.com/TobiasHubold" target="_blank"><img src="https://cdn.buymeacoffee.com/buttons/default-orange.png" alt="Buy Me A Coffee" style="height: 45px !important;width: 200px !important;" ></a>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  name: 'RTdonate',
  props:{
    show_header:{
      type:Boolean,
      default:true,
    },
    text:{
      type:String,
      default:null
    }
  },
  data: function() {
    return {
    };
  },
};
</script>

<style scoped type='text/css'>

</style>